import { useExpEnabled } from '@reverbdotcom/commons/src/user_hooks';
import experiments from '@reverbdotcom/commons/src/experiments';
import {
  core_apimessages_CheckoutPaymentMethod_Type as CheckoutPaymentMethodType,
} from '@reverbdotcom/commons/src/gql/graphql';
import { useURL } from '@reverbdotcom/commons/src/url_context';
import { reverbAppQueryValue } from '../checkoutActionHooks';

export function useStandalonePayPalExp(paymentMethodType: CheckoutPaymentMethodType = CheckoutPaymentMethodType.PAYPAL) {
  const url = useURL();
  const isInStandalonePayPalCart = useExpEnabled(experiments.STANDALONE_PAYPAL_CART);

  return paymentMethodType === CheckoutPaymentMethodType.PAYPAL && isInStandalonePayPalCart && !reverbAppQueryValue(url);
}
